import { isProductEvaluator, type AccessUserLike } from '../auth/access';

export type ProductEvaluatorEvaluationScope = {
  cameraId: string | null;
  deviceId: string | null;
};

const EVALUATION_SCOPE_PATHS = new Set(['/live-view', '/cameras', '/zones', '/policies', '/incidents']);

export function isProductEvaluatorEvaluationScopePath(pathname: string): boolean {
  return EVALUATION_SCOPE_PATHS.has(String(pathname || '').trim());
}

/** Static evaluation camera/device from build-time env (optional). */
export function getStaticProductEvaluatorEvaluationScope(): ProductEvaluatorEvaluationScope {
  return {
    cameraId: String(process.env.REACT_APP_EVALUATION_CAMERA_ID || '').trim() || null,
    deviceId: String(process.env.REACT_APP_EVALUATION_DEVICE_ID || '').trim() || null,
  };
}

export function extractEvaluationScopeFromSafetyCaseScope(
  scope: Record<string, unknown> | null | undefined,
): ProductEvaluatorEvaluationScope {
  const payload = scope && typeof scope === 'object' ? scope : {};
  const cameraId = String(payload.camera_id || '').trim() || null;
  const deviceId =
    String(payload.device_id || payload.edge_device_id || '').trim() || null;
  return { cameraId, deviceId };
}

export function mergeEvaluationScopeIntoSearchParams(
  user: AccessUserLike,
  params: URLSearchParams,
  scope: ProductEvaluatorEvaluationScope,
): URLSearchParams | null {
  if (!isProductEvaluator(user)) return null;
  if (params.get('camera_id')) return null;
  if (!scope.cameraId && !scope.deviceId) return null;

  const next = new URLSearchParams(params);
  if (scope.cameraId) next.set('camera_id', scope.cameraId);
  if (scope.deviceId) next.set('device_id', scope.deviceId);
  return next;
}
